import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-game-skill-item',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './game-skill-item.component.html',
  styleUrls: ['./game-skill-item.component.scss']
})
export class GameSkillItemComponent implements OnInit {

  @Input() skill: any;
  @Input() type: string;

  constructor() {
  }

  ngOnInit() {
  }

}
